export function isPendoInternalSubscription (subscription) {
    return subscription?.name === 'pendo-internal';
}

export function hasPendoSubscriptionAnalyticsProductLine (hasProductLinePurchased) {
    return hasProductLinePurchased('core', 'pendoSubAnalyticsEnabled');
}

export function shouldShowAdoptSharedCountablePartnerAlert ({
    subscription,
    hasProductLinePurchased,
    isEnabledForAdopt,
    isSharedForPartnerAnalytics,
    isInheritedForPartnerAnalytics,
}) {
    return (
        isEnabledForAdopt &&
        !isSharedForPartnerAnalytics &&
        !isInheritedForPartnerAnalytics &&
        isPendoInternalSubscription(subscription) &&
        !hasPendoSubscriptionAnalyticsProductLine(hasProductLinePurchased)
    );
}
